export const STEP_NAMES = {
    Overview: "Overview",
    Review: "Review"
}